import useRedirectHandler from './useRedirectHandler'
export default useRedirectHandler
